import { blazeDiscoveryOptions } from 'screens/LoginOrSignup/components/CompanyData/utils'
import { RegistrationStepProps } from 'screens/Registration/types'
import Styles from './Referrer.module.scss'
import { shuffle } from 'lodash'
import { useMemo } from 'react'
import { Chip } from 'components/Chip/Chip'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useSelectionHandler } from 'screens/Registration/hooks/useSelectionHandler'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'

export const Referrer: React.FC<RegistrationStepProps> = ({ onNext, onBack }) => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const shuffledOptions = useMemo(() => shuffle(blazeDiscoveryOptions), [])
  const { isMobile } = useResponsiveDesign()

  const options = isOnboardingRedesign ? blazeDiscoveryOptions : shuffledOptions

  const { selectedValue, handleSelection, handleNext } = useSelectionHandler({
    paramName: 'discoverySource',
    onNext: isMobile ? () => {} : onNext,
    dataKey: 'discoverySource',
  })

  return (
    <MultiStepStepLayout
      title="How did you hear about us?"
      onBack={isMobile ? undefined : onBack}
      onNext={isMobile ? onNext : handleNext}
      isNextButtonDisabled={!selectedValue}
      withArrowLeft={!isOnboardingRedesign}
      withArrowRight={!isOnboardingRedesign}
    >
      <div className={Styles.options}>
        {options.map((option) => (
          <Chip
            size="xxl"
            icon={() => <span className={Styles.emoji}>{option.icon}</span>}
            key={option.title}
            onPress={() => handleSelection(option.value)}
            variant="flat"
            selectable={!isMobile}
            isSelected={selectedValue === option.value}
            deletable={false}
          >
            {option.title}
          </Chip>
        ))}
      </div>
    </MultiStepStepLayout>
  )
}
